// extracted by mini-css-extract-plugin
export var firstItem = "EventsList-module--firstItem--1d938";
export var lastItem = "EventsList-module--lastItem--ff591";
export var listItem = "EventsList-module--listItem--1746e";
export var root = "EventsList-module--root--02f8a";